import { render, staticRenderFns } from "./CreateAdditionalVisitor.vue?vue&type=template&id=6dcdb130&"
import script from "./CreateAdditionalVisitor.vue?vue&type=script&lang=js&"
export * from "./CreateAdditionalVisitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports